/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recap_My_DonationInputs */

const en_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recap my donation`)
};

const ar_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مراجعة تبرعاتي`)
};

const de_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spendenrückblick`)
};

const es_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de mi donación`)
};

const fr_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récapituler mes dons`)
};

const it_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo della mia donazione`)
};

const ja_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄付の振り返り`)
};

const ko_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나의 기부 내역`)
};

const pt_br_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo da minha doação`)
};

const ru_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор моего пожертвования`)
};

const th_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สรุปการบริจาคของฉัน`)
};

const tr_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağışımı gözden geçir`)
};

const zh_cn_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回顾我的捐赠`)
};

const zh_tw_recap_my_donation = /** @type {(inputs: Recap_My_DonationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回顧我的捐贈`)
};

/**
* | output |
* | --- |
* | "Recap my donation" |
*
* @param {Recap_My_DonationInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const recap_my_donation = /** @type {((inputs?: Recap_My_DonationInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recap_My_DonationInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recap_my_donation(inputs)
	if (locale === "ar") return ar_recap_my_donation(inputs)
	if (locale === "de") return de_recap_my_donation(inputs)
	if (locale === "es") return es_recap_my_donation(inputs)
	if (locale === "fr") return fr_recap_my_donation(inputs)
	if (locale === "it") return it_recap_my_donation(inputs)
	if (locale === "ja") return ja_recap_my_donation(inputs)
	if (locale === "ko") return ko_recap_my_donation(inputs)
	if (locale === "pt_br") return pt_br_recap_my_donation(inputs)
	if (locale === "ru") return ru_recap_my_donation(inputs)
	if (locale === "th") return th_recap_my_donation(inputs)
	if (locale === "tr") return tr_recap_my_donation(inputs)
	if (locale === "zh_cn") return zh_cn_recap_my_donation(inputs)
	return zh_tw_recap_my_donation(inputs)
});